import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { propertyTypesApi as n } from "@maat/api-main";
//#region src/propertyTypes/useSetPropertyTypePopularMutation.ts
var r = () => {
	let r = t();
	return e({
		mutationFn: ({ id: e, isPopular: t }) => n.setPopular(e, t),
		onSuccess: () => {
			r.invalidateQueries({ queryKey: ["propertyTypes"] });
		}
	});
};
//#endregion
export { r as useSetPropertyTypePopularMutation };
